import { makeStyles } from '@material-ui/core/styles'
import { coachProfileModalStyleRules } from '@components/coach-profile-modal'

/**
 * Styles for `CoachAccreditationExplainerDialog`.
 *
 * Shared modal chrome lives in `@components/coach-profile-modal`.
 * Crest row and CTA prompt styles are specific to accreditation explainers.
 */
const useStyles = makeStyles((theme) => ({
  ...coachProfileModalStyleRules(theme),
  crests: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0.25, 0),
      gap: theme.spacing(2),
    },
  },
  crestsTight: {
    padding: 0,
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(2),
    },
  },
  crestItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  crestImage: {
    display: 'block',
    height: 92,
    width: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.up('sm')]: {
      height: 104,
    },
  },
  crestImageMulti: {
    height: 100,
    [theme.breakpoints.up('sm')]: {
      height: 112,
    },
  },
  crestImageWide: {
    height: 'auto',
    maxHeight: 44,
    maxWidth: 128,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 48,
      maxWidth: 140,
    },
  },
  crestImageHope: {
    height: 'auto',
    maxHeight: 60,
    maxWidth: 120,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 68,
      maxWidth: 132,
    },
  },
  ctaPrompt: {
    margin: 0,
    color: theme.palette.text.primary,
    '&&': {
      textAlign: 'center',
      fontWeight: 700,
    },
  },
}))

export default useStyles
